import Typography from "../../shared/typography/Typography";
import { InputFile, StyledLabel } from "./style";

interface IProps {
  id: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  multiple?: boolean;
}

export const FileUploadButton = ({id, label, onChange, multiple=false}: IProps) => {
  return (
    <>
      <StyledLabel htmlFor={id}>
        <Typography className="label" type="headingXXS" color="title">{label}</Typography>
      </StyledLabel>
      <InputFile multiple={multiple} id={id} type="file" onChange={onChange} />
    </>
  );
}